import { THALYS_PASS_TICKETS_CODES } from 'constants/clubEurostar';
import {
  COMMERCIAL_GESTURE,
  PARTIAL_COMMERCIAL_GESTURE,
  WITHDRAWAL_PERIOD,
  MEDICAL_CONDITION,
  VAT
} from 'constants/subscriptionCancellationReasons';

export const getProducts = (subscriptionBookings) =>
  subscriptionBookings?.map(({ tickets }) => tickets?.map(({ products }) => products)?.flat())?.flat();

export const hasNotCancelledThalysPassTickets = (products) =>
  !!products?.find((product) => !product.isCancelled && THALYS_PASS_TICKETS_CODES.includes(product.code));

export const isInvalidCoollingOfPeriodReason = (reason) => (reason !== WITHDRAWAL_PERIOD && reason !== VAT ? true : false);

export const isInvalidPastBookingsReason = (isThalysAdminUserOffice, reason) => {
  if (isThalysAdminUserOffice && reason !== PARTIAL_COMMERCIAL_GESTURE && reason !== MEDICAL_CONDITION && reason !== VAT) return true;
  if (!isThalysAdminUserOffice && reason !== MEDICAL_CONDITION && reason !== VAT) return true;
  return false;
};

export const isInvalidReasonNoPastBookings = (isThalysAdminUserOffice, reason) => {
  if (isThalysAdminUserOffice && reason === WITHDRAWAL_PERIOD) return true;
  if (!isThalysAdminUserOffice && reason !== VAT && reason !== MEDICAL_CONDITION && reason !== COMMERCIAL_GESTURE) return true;
  return false;
};
